import React from 'react';
import { ReactComponent as SpinnerSVG } from 'src/assets/images/spinner.svg';
import styles from './Spinner.module.scss';
import { testIds } from 'src/app/constants';
import { t } from 'i18next';

/**
 * Presentational spinner component with spinning animation
 */
function Spinner() {
  return (
    <div id={testIds.spinner} className={styles.spinnerSvg}>
      <div className='sr-only' aria-live='assertive'>
        {t('LOADING')}
      </div>
      <SpinnerSVG />
    </div>
  );
}

export default Spinner;
